export enum AppStartStates {
   Init = 'Init',
   ExistingSessionFound = 'ExistingSessionFound',
   VerifyingSession = 'VerifyingSession',
   SessionInvalid = 'SessionInvalid',
   Complete = 'Complete',
}
